type Props = {
  template: any;
  selectedId: string;
  onSelect: (template: any) => void;
};

const TemplateCard = ({ template, selectedId, onSelect }: Props) => {
  return (
    <div
      onClick={() => onSelect(template)}
      className={`

      cursor-pointer
      rounded-xl
      border-2
      p-4
      transition
      hover:shadow-lg

      ${
        selectedId === template.id
          ? 'border-blue-600 shadow-md'
          : 'border-gray-200 hover:border-blue-400'
      }

      `}
    >
      <img
        src={template.templateUrl}
        alt={template.name}
        className='h-72 w-full rounded object-cover'
      />

      <p className='mt-3 text-center font-medium'>
        {template.templateName || template.name || 'Template'}
      </p>
    </div>
  );
};

export default TemplateCard;
